import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { VxBreadcrumbItemComponent } from '@ui/breadcrumb/breadcrumb-item.component';
import { VxBreadcrumbComponent } from '@ui/breadcrumb/breadcrumb.component';
import { VxIconComponent } from '@ui/icon/icon.component';
import { VxSkeletonComponent } from '@ui/skeleton/skeleton.component';
import { BreadcrumbService } from 'src/app/services/breadcrumb/breadcrumb.service';

/**
 * Content-shell top bar: the breadcrumb trail for the active route, built
 * from the domain-free vx-breadcrumb kit pieces and BreadcrumbService.
 */
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoModule,
    VxBreadcrumbComponent,
    VxBreadcrumbItemComponent,
    VxIconComponent,
    VxSkeletonComponent,
  ],
  host: { class: 'block font-brand' },
})
export class TopbarComponent {
  private breadcrumbService = inject(BreadcrumbService);

  protected readonly breadcrumbs = this.breadcrumbService.breadcrumbs;
}
